import { IProfitLossFiltersDto } from "../interfaces/dashboard/IProfitLossFiltersDto";
import { IGlobalAction } from "../interfaces/states/IGlobalAction";

export const profitLossFilterInitialState: IProfitLossFiltersDto = {
    walletIdList: [],
    cryptoCurrencyIdList: [],
    isActiveWallet: true
}

export function profitLossFiltersReducer(state: IProfitLossFiltersDto, action: IGlobalAction) : IProfitLossFiltersDto {
    switch (action.type) {
        case 'SET_PROFIT_LOSS_FILTERS':
            return { ...state, ...action.payload };
        case 'RESET_PROFIT_LOSS_FILTERS':
            return profitLossFilterInitialState;
        default:
            return state;
    }
}